<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->
<template>

  <input
      v-if="type === 'checkbox'"
      :type="type"
      :checked="modelValue"
      @input="$emit('update:modelValue', $event.target.checked)"

      :placeholder="placeholder"
      class="px-2 py-4 disabled:bg-secondary-250 disabled:dark:bg-secondary disabled:text-secondary disabled:dark:text-white border-secondary-250 disabled:border-secondary-350 focus:outline-[#ece4d9] "
      :class="{'checkbox-secondary rounded-xs w-fit': type === 'checkbox', 'input input-secondary input-sm w-full max-w-full': type !== 'checkbox'}"
      :disabled="disabled"
  />
  <input
      v-else
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      @input="$emit('update:modelValue', $event.target.value)"
      class="px-2 py-4 disabled:bg-secondary-250 disabled:dark:bg-secondary disabled:text-secondary disabled:dark:text-white border-secondary-250 disabled:border-secondary-350 focus:outline-[#ece4d9] "
      :class="{'checkbox-secondary rounded-xs w-fit': type === 'checkbox', 'input input-secondary input-sm w-full max-w-full': type !== 'checkbox'}"
      :disabled="disabled"
  />

</template>

<script>
export default {
  name: "InputComponent",
  props: ["modelValue", "type", "placeholder", "disabled"]
};
</script>

<style scoped>

</style>